module.exports = __webpack_public_path__ + "img/1440.ce0c2dd0.jpg";